import { Region } from 'pages/Map/types';

export const getReferenceRegionNames = (region: Region) => {
    return region.zones
        .map(zone => {
            if (zone.ref) {
                return zone.ref.region;
            }
        })
        .filter(Boolean) as string[];
};
